<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, IconButton, Popover } from '@Shelly/shelly-design-system';
	import CustomDynamicInput from 'src/components/CustomDynamicInput.svelte';

	export let repeat_period: number;
</script>

<div class="d-flex align-items-center mb-s">
	<Text styleType="h2">
		{$format('webhook_repeat_when_title', {
			default: 'Repeat When',
		})}
	</Text>

	<Popover type="hover" hideCloseBtn placement="top">
		<IconButton
			aria-label={$format('button_info', { default: 'Button info' })}
			class="ml-xs"
			icon="fas fa-circle-info"
			variant="help"
		/>
		<svelte:fragment slot="customContent">
			<Text styleType="body-small">
				{$format('popover_message_minimum_interval', {
					default:
						"Defines the minimum interval, in seconds, between two consecutive invocations of the hook. Any events that would trigger the hook within this time window will be suppressed and won't cause a new invocation.",
				})}
			</Text>
		</svelte:fragment>
	</Popover>
</div>

<Text styleType="body-small" class="mb-s">
	{@html $format('webhook_repeat_when_subtitle', {
		values: {
			value: `${repeat_period}`,
		},
		default: `Minimum interval between hook invocations <span class="text-primary text-bold">${repeat_period}</span> seconds.`,
	})}
</Text>

<CustomDynamicInput
	additionalInputClass="width-s"
	minusFunction={() => {
		repeat_period -= 1;
	}}
	disabledMinusBtn={repeat_period <= 0}
	plusFunction={() => {
		repeat_period += 1;
	}}
	value={repeat_period}
	error={null}
	inputHandler={(e) => {
		repeat_period = Number(e.target['value']);
	}}
/>
